import React, { useState } from "react";

import { useIntl } from "react-intl";

import Button from "ds/Button";
import { Tooltip } from "ds/Tooltip";
import { selectContinousProfillingSellableEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useUrlParamsSubscription } from "Reducers/organization/subscription/hooks";
import Sellable from "src/organization/common/components/sellableBanners/Sellable";
import { useAppSelector } from "Store/hooks";

import ProfilingSellableModalContent from "./Modal";
import * as S from "./ProfilingSellable.styles";

import type { OrganizationSubscription } from "@packages/client";

type ProfilingSellableProps = {
  subscription?: OrganizationSubscription;
};
const ProfilingSellable = (props: ProfilingSellableProps) => {
  const intl = useIntl();
  const [openModal, setOpenModal] = useState(false);

  const modalProps = {
    Comp: ProfilingSellableModalContent,
    open: openModal,
    onClose: setOpenModal
  };
  const subscription = useUrlParamsSubscription() || props.subscription;

  const canUpdate = subscription?.hasLink?.("update");
  const enabled = useAppSelector(selectContinousProfillingSellableEnabled);
  return enabled ? (
    <Sellable
      modal={modalProps}
      size="small"
      sellableName="continuous_profiling"
    >
      <S.SellableContent>
        <S.SellableTitle className="header">
          {intl.formatMessage({
            id: "add_on.continous_profile_retain_message"
          })}
        </S.SellableTitle>
        <Tooltip
          align="start"
          tooltip={intl.formatMessage({ id: "request_admin_enable" })}
          open={canUpdate ? false : undefined}
          analyticId="request_admin_enable"
        >
          <Button
            analyticId="enable"
            disabled={!canUpdate}
            onClick={() => {
              setOpenModal(!openModal);
            }}
          >
            {intl.formatMessage({ id: "enable" })}
          </Button>
        </Tooltip>
      </S.SellableContent>
    </Sellable>
  ) : null;
};

export default ProfilingSellable;
